import { SettingsList } from "../SettingsList";
import { ComparisonRowData, ComparisonTableProps } from "../types";

import {
  getContractorsCurrentValue,
  getContractorsNewValue
} from "./getContractorsValues";
import { getExpirationLabel } from "./getExpirationLabel";
import { getManualRenewalLabel } from "./getManualRenewalLabel";
import { getRequirementSettingsItems } from "./getRequirementSettingsItems";
import { getReviewStrategyLabel } from "./getReviewStrategyLabel";
import {
  getTransitionCurrentValue,
  getTransitionNewValue
} from "./getTransitionValues";

export const buildComparisonTableData = (
  props: ComparisonTableProps
): Array<{ data: ComparisonRowData; id: string }> => {
  const contractorsCurrent = getContractorsCurrentValue(
    props.scope,
    props.completeCount,
    props.incompleteCount
  );
  const contractorsNew = getContractorsNewValue(
    props.scope,
    props.completeCount,
    props.incompleteCount
  );
  const transitionCurrent = getTransitionCurrentValue(
    props.scope,
    props.transitionMethod
  );
  const transitionNew = getTransitionNewValue(
    props.scope,
    props.transitionMethod,
    props.renewalDeadlineDays
  );
  const newSettingsKeys = new Set(Object.keys(props.newSettings));
  const filteredCurrentSettings = Object.fromEntries(
    Object.entries(props.currentSettings).filter(([key]) =>
      newSettingsKeys.has(key)
    )
  ) as typeof props.currentSettings;

  const currentReqSettingsItems = getRequirementSettingsItems(
    props.requirementType,
    filteredCurrentSettings
  );
  const newReqSettingsItems = getRequirementSettingsItems(
    props.requirementType,
    props.newSettings
  );

  return [
    {
      data: {
        currentValue: contractorsCurrent.primary,
        disabledCurrent: contractorsCurrent.disabled,
        label: "Contractors",
        newValue: contractorsNew.primary,
        secondaryCurrentValue: contractorsCurrent.secondary,
        secondaryNewValue: contractorsNew.secondary
      },
      id: "contractors"
    },
    {
      data: {
        currentValue: transitionCurrent.primary,
        disabledCurrent: transitionCurrent.disabled,
        label: "Transition",
        newValue: transitionNew.primary,
        secondaryCurrentValue: transitionCurrent.secondary,
        secondaryNewValue: transitionNew.secondary
      },
      id: "transition"
    },
    {
      data: {
        currentValue: SettingsList({ items: currentReqSettingsItems }),
        label: "Requirement\nsettings",
        newValue: SettingsList({ items: newReqSettingsItems })
      },
      id: "requirementSettings"
    },
    {
      data: {
        currentValue: getExpirationLabel(
          props.currentSettings.expirationStrategy,
          props.currentSettings.expirationDays
        ),
        label: "Expiration",
        newValue: getExpirationLabel(
          props.newSettings.expirationStrategy,
          props.newSettings.expirationDays
        ),
        secondaryCurrentValue: getManualRenewalLabel(
          props.currentSettings.manualRenewalAllowed
        ),
        secondaryNewValue: getManualRenewalLabel(
          props.newSettings.manualRenewalAllowed
        )
      },
      id: "expiration"
    },
    {
      data: {
        currentValue: getReviewStrategyLabel({
          contextType: (props.dataSourceSettings as any)?.contextType,
          isApprovalRequired: props.currentSettings.isApprovalRequired,
          reviewStrategy: props.currentSettings.reviewStrategy,
          type: props.requirementType
        }),
        label: "Approvals",
        newValue: getReviewStrategyLabel({
          contextType: (props.dataSourceSettings as any)?.contextType,
          isApprovalRequired: props.newSettings.isApprovalRequired,
          reviewStrategy: props.newSettings.reviewStrategy,
          type: props.requirementType
        })
      },
      id: "approvals"
    }
  ];
};
